export enum ScreenOrientation {
  PORTRAIT = "PORTRAIT",
  LANDSCAPE = "LANDSCAPE"
}
